import { tw } from "@careinfo/tailwind";
import { Link, useSearchParams } from "react-router-dom";
import PlusIcon from "../../../../Icons/PlusIcon";
import SearchIcon from "../../../../Icons/SearchIcon";

interface Props {
  addNew?: {
    path: string;
    label: string;
  };
}

export default function TableSearch({ addNew = null }: Props) {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <div className={tw`flex items-center gap-x-4`}>
      <label
        htmlFor="journal-search"
        className={tw`flex items-center border p-2 bg-[#fefefe] rounded-md`}
      >
        <span className="sr-only hidden">Search Journal</span>
        <input
          type="text"
          id="journal-search"
          placeholder="Search "
          className={tw`w-96 rounded-sm bg-transparent focus:outline-none`}
          value={searchParams.get("search")}
          onChange={(e) => {
            const clonedSearchParams = new URLSearchParams(searchParams);
            clonedSearchParams.set("search", e.target.value);
            setSearchParams(clonedSearchParams);
          }}
        />
        <span className={tw`block w-6 h-6`}>
          <SearchIcon />
        </span>
      </label>
      {addNew && (
        <Link
          to={addNew.path}
          className={tw`flex items-center whitespace-nowrap justify-center gap-x-4 bg-primary text-white min-w-32 py-1 px-5 rounded-md focus:outline-none focus-visible:ring focus-visible:ring-primary-light`}
        >
          <span className={tw`block w-7 h-7`}>
            <PlusIcon />
          </span>
          {addNew.label}
        </Link>
      )}
    </div>
  );
}
